/**
 * Pure frame-step clock for sprite animations (M2 lab). Accumulates time
 * and yields the looping frame index at the animation's fps. Pure functions
 * over plain numbers — unit-tested, no DOM. The lab drives it from rAF
 * time; the game will do the same later (cosmetic interpolation only).
 */

export interface AnimClock {
  fps: number;
  frames: number;
  /** Accumulated ms. */
  t: number;
}

export function createClock(fps: number, frames: number): AnimClock {
  return { fps, frames, t: 0 };
}

/** Advance by dtMs; returns the frame index to display (loops forever). */
export function advanceClock(clock: AnimClock, dtMs: number): number {
  clock.t += Math.max(0, dtMs);
  const per = 1000 / clock.fps;
  return Math.floor(clock.t / per) % clock.frames;
}

/** Frame index for an accumulated walk distance (in tiles), looping forever.
 * The stride spans `1 / cyclesPerTile` tiles per full frame cycle, so
 * footfall frames line up with distance traveled — the walk animation is
 * distance-driven, not wall-clock-driven. */
export function frameForCycle(distTiles: number, cyclesPerTile: number, frames: number): number {
  if (frames <= 0) return 0;
  return Math.floor(distTiles * cyclesPerTile * frames) % frames;
}
